// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"1a370886","845":"1f8fb048"}[chunkId] + ".chunk.js";
};